import {
    DOCUMENTS_SHARE_ITEM_INIT,
    DOCUMENTS_SHARE_ITEM_CANCEL,
    DOCUMENTS_SHARE_EMAILS_FETCH_DATA_STORE,
    DOCUMENTS_LINK_LOADING,
    DOCUMENTS_LINK_LOADING_FINISHED,
} from '../actions/actionsNamesList';

const defaultState = {
    share: {
        isOpen: false,
        title: '',
        id: null,
        documentType: null,
        shareLinkString: null,
        publicationFamily: null,
        emails: []
    },
    downloadingFile: false,
};

export default function documentsData(state = defaultState, action) {
    switch (action.type) {
        case DOCUMENTS_SHARE_ITEM_INIT: {
            return {
                ...state,
                share: {
                    ...state.share,
                    isOpen: true,
                    title: action.params.title,
                    id: action.params.id,
                    documentType: action.params.documentType,
                    shareLinkString: action.params.shareLinkString,
                    publicationFamily: action.params.publicationFamily
                }

            };
        }
        case DOCUMENTS_SHARE_ITEM_CANCEL: {
            return {
                ...state,
                share: {
                    ...state.share,
                    isOpen: false,
                    title: '',
                    id: null,
                    documentType: null,
                    shareLinkString: null,
                    publicationFamily: null,
                }
            };
        }
        case DOCUMENTS_SHARE_EMAILS_FETCH_DATA_STORE: {
            return {
                ...state,
                share: {
                    ...state.share,
                    emails: action.data
                }
            };
        }
        case DOCUMENTS_LINK_LOADING: {
            return {
                ...state,
                downloadingFile: true
            };
        }
        case DOCUMENTS_LINK_LOADING_FINISHED: {
            return {
                ...state,
                downloadingFile: false
            };
        }
        default: {
            return state;
        }
    }
}
